/**
 * Office API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';


class OfficeCreate {
    
    constructor(companyId, name, city, street, homeNum, phone) { 
        
        OfficeCreate.initialize(this, companyId, name, city, street, homeNum, phone);
    }

    
    static initialize(obj, companyId, name, city, street, homeNum, phone) { 
        obj['companyId'] = companyId;
        obj['name'] = name;
        obj['city'] = city;
        obj['street'] = street;
        obj['homeNum'] = homeNum;
        obj['phone'] = phone;
    }

    
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new OfficeCreate();

            if (data.hasOwnProperty('companyId')) {
                obj['companyId'] = ApiClient.convertToType(data['companyId'], 'Number');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('city')) {
                obj['city'] = ApiClient.convertToType(data['city'], 'String');
            }
            if (data.hasOwnProperty('index')) {
                obj['index'] = ApiClient.convertToType(data['index'], 'String');
            }
            if (data.hasOwnProperty('street')) {
                obj['street'] = ApiClient.convertToType(data['street'], 'String');
            }
            if (data.hasOwnProperty('homeNum')) {
                obj['homeNum'] = ApiClient.convertToType(data['homeNum'], 'String');
            }
            if (data.hasOwnProperty('structNum')) {
                obj['structNum'] = ApiClient.convertToType(data['structNum'], 'String');
            }
            if (data.hasOwnProperty('enterNum')) {
                obj['enterNum'] = ApiClient.convertToType(data['enterNum'], 'String');
            }
            if (data.hasOwnProperty('floor')) {
                obj['floor'] = ApiClient.convertToType(data['floor'], 'String');
            }
            if (data.hasOwnProperty('phone')) {
                obj['phone'] = ApiClient.convertToType(data['phone'], 'String');
            }
        }
        return obj;
    }


}


OfficeCreate.prototype['companyId'] = undefined;


OfficeCreate.prototype['name'] = undefined;


OfficeCreate.prototype['city'] = undefined;


OfficeCreate.prototype['index'] = undefined;


OfficeCreate.prototype['street'] = undefined;


OfficeCreate.prototype['homeNum'] = undefined;


OfficeCreate.prototype['structNum'] = undefined;


OfficeCreate.prototype['enterNum'] = undefined;


OfficeCreate.prototype['floor'] = undefined;


OfficeCreate.prototype['phone'] = undefined;






export default OfficeCreate;

